/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class AdjustmentController {
        public static $inject: string[] = [
            '$filter',
            '$scope',
            '$timeout',
            '$mdDialog',
            '$mobilityCompanyAuthentication',
            'DealerwareContractModel',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'contract',
            'adjustmentType'
        ];

        public addingLineItem: boolean = false;
        public addingAdjustment: boolean = false;
        public isCredit: boolean = false;
        public adjustment: any;

        constructor(public $filter: any,
                    public $scope: any,
                    public $timeout: any,
                    public $mdDialog: any,
                    public auth: any,
                    public contractModel: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public contract: any,
                    public adjustmentType: any) {
            this.adjustment = {
                type_id: this.adjustmentType.id,
                amount: 0
            };

            if (this.invoiceItems.length === 0) {
                this.addLineItem();
            }
        }

        public get categoryTotal() : number {
            var pricingKey = this.adjustmentType.pricing_key,
                invoice = this.contract.currentInvoice;

            if (pricingKey && invoice.pricingSection[pricingKey]) {
                return parseFloat(invoice.pricingSection[pricingKey].items.reduce((a: number, b: any) => a + b.total, 0).toFixed(2));
            }

            return 0;
        }

        public get formattedCategoryTotal() : string {
            return this.$filter('customCurrency')(this.categoryTotal,
                                                  this.auth.location.settings.currency_code);
        }

        public get invoiceItems() : any {
            var pricingKey = this.adjustmentType.pricing_key,
                invoice = this.contract.currentInvoice;

            if (!pricingKey || !invoice.pricingSection[pricingKey]) { return []; }
            return invoice.pricingSection[pricingKey].items;
        }

        public addLineItem(isCredit?: boolean) : void {
            this.addingLineItem = true;
            this.isCredit = isCredit;
            this.$timeout(() => { angular.element('#amount').select(); });
        }

        public handleInputKeypress(e: any) : void {
            if (e.keyCode === 13) {
                if (e.target.id === 'amount') {
                    angular.element('#description').select();
                } else if (e.target.id === 'description' && !this.addingAdjustment) {
                    if (this.$scope.adjustmentForm.$valid) {
                        this.addingAdjustment = true;
                        this.applyAdjustment();
                    } else {
                        this.showMissingDescriptionAlert();
                    }
                }
            }
        }

        public applyAdjustment(hideAdjustmentModal: boolean = false) : void {
            if (this.isCredit && Number(this.adjustment.amount) > this.categoryTotal) {
                this.$dealerwareNotification.error(`Credit amount cannot exceed the total ${this.adjustmentType.label.toLowerCase()} charges.`);
                return;
            }

            var loader = this.$dealerwareLoading.show('Updating Balance...');
            this.adjustment.amount = this.isCredit ? -Math.abs(Number(this.adjustment.amount)) : Number(this.adjustment.amount);
            this.contractModel.applyBalanceAdjustment({
                promise: true,
                data: this.adjustment,
                params: {
                    location_id: this.contract.locationId,
                    id: this.contract.contractId
                }
            }).then(
                () => {
                    this.contract.loadCurrentInvoice().finally(() => {
                        this.clearAdjustmentForm();
                        loader.close();
                        this.addingAdjustment = false;
                        if (hideAdjustmentModal) {
                            this.$mdDialog.hide();
                        } else {
                            angular.element('#done')[0].focus();
                        }
                    });
                },
                (response: any) => {
                    loader.close();
                    this.addingAdjustment = false;
                    this.$dealerwareNotification.apiError(response);
                }
            );
        }

        public negateAdjustment(item: any) : void {
            if (item.total <= this.categoryTotal) {
                var confirmText = item.total > 0 ? 'We will reverse this charge by adding a credit for the exact same amount.'
                                                 : 'We will reverse this credit by adding a charge for the exact same amount.';

                this.$mdDialog.show(this.$mdDialog.confirm()
                    .textContent(confirmText)
                    .ariaLabel(confirmText)
                    .multiple(true)
                    .cancel('Cancel')
                    .ok('OK')).then(() => {
                        var loader = this.$dealerwareLoading.show('Updating Balance...')
                        this.adjustment = {
                            type_id: this.adjustmentType.id,
                            description: item.label,
                            amount: -(item.total)
                        }

                        this.contractModel.applyBalanceAdjustment({
                            promise: true,
                            data: this.adjustment,
                            params: {
                                location_id: this.contract.locationId,
                                id: this.contract.contractId
                            }
                        }).then(
                            () => {
                                this.contract.loadCurrentInvoice().finally(() => {
                                    this.clearAdjustmentForm();
                                    loader.close();
                                });
                            },
                            (response: any) => {
                                loader.close();
                                this.$dealerwareNotification.apiError(response);
                            }
                        );
                    }
                );
            } else {
                this.$dealerwareNotification.error('Credit amount cannot exceed the total ' + this.adjustmentType.label.toLowerCase() + ' charges.');
            }
        }

        public clearAdjustmentForm() : void {
            this.$scope.adjustmentForm.$setPristine();
            this.addingLineItem = false;
            this.isCredit = false;
            this.adjustment = {
                type_id: this.adjustmentType.id,
                amount: 0
            };
        }

        public showMissingDescriptionAlert() : void {
            this.$dealerwareNotification.alert(
                undefined,
                'Please enter a description for each charge/credit.',
                undefined,
                undefined,
                () => { angular.element('#description').select(); }
            );
        }

        public closeModal() : void {
            if (this.$scope.adjustmentForm.$pristine) {
                this.$mdDialog.hide();
            } else {
                if (this.$scope.adjustmentForm.description.$invalid) {
                    this.showMissingDescriptionAlert();
                } else {
                    this.$mdDialog.show(this.$mdDialog.confirm()
                        .textContent('Apply changes?')
                        .ariaLabel('confirm')
                        .ok('Yes')
                        .cancel('No')
                        .multiple(true)
                    ).then(() => {
                        this.applyAdjustment(true);
                    }, () => {
                        this.$mdDialog.hide();
                    });
                }
            }
        }
    }

    getDealerwareWebComponentsModule().controller('AdjustmentController', AdjustmentController);
}
